<template>
  <div>
    <!-- Form groups used in grid -->
    <form class="needs-validation" @submit.prevent="saveVisit">
      <div class="row">
        <div class="col-sm-12">
          <div v-if="!schedule" class="form-group">
            <label class="control-label">Fecha de Visita</label>

            <el-date-picker
              ref="visitDate"
              v-model="formData.visitDate"
              v-validate="modelValidations.visitDate"
              align="center"
              :editable="false"
              format="dd-MM-yyyy HH:mm"
              name="visitDate"
              placeholder="Fecha de visita (*)"
              suffix-icon="fas fa-calendar-alt"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>

            <small v-show="visitDate.invalid" class="text-danger">
              {{ getError('visitDate') }}
            </small>
          </div>

          <div v-if="schedule" class="form-group">
            <label class="control-label">Fecha Programada</label>

            <el-date-picker
              v-model="formData.appointmentDate"
              v-validate="modelValidations.appointmentDate"
              align="center"
              :editable="false"
              :picker-options="{ disabledDate: disabledDate }"
              format="dd-MM-yyyy HH:mm"
              name="appointmentDate"
              placeholder="Fecha Programada (*)"
              suffix-icon="fas fa-calendar-alt"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>

            <small v-show="appointmentDate.invalid" class="text-danger">
              {{ getError('appointmentDate') }}
            </small>
          </div>

          <div class="form-group">
            <label class="control-label">Detalle</label>

            <el-input
              v-model="formData.details"
              v-validate="modelValidations.details"
              cy-id="visit-detail"
              :autosize="{ minRows: 5 }"
              name="details"
              placeholder="Ingrese el detalle de la visita"
              type="textarea"
              :disabled="!formData.hasParticipants"
            >
            </el-input>

            <small v-show="details.invalid" class="text-danger d-block">
              {{ getError('details') }}
            </small>
            <small v-if="!formData.hasParticipants" class="text-danger">
              Debe seleccionar al menos un participante para la visita
            </small>
          </div>

          <div v-if="!schedule" class="form-group">
            <label class="control-label">Fecha de Proxima Visita</label>

            <el-date-picker
              v-model="formData.visitNextDate"
              v-validate="modelValidations.visitNextDate"
              align="center"
              :editable="false"
              format="dd-MM-yyyy HH:mm"
              name="visitNextDate"
              placeholder="Fecha de próxima visita (*)"
              suffix-icon="fas fa-calendar-alt"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>

            <small v-show="visitNextDate.invalid" class="text-danger">
              {{ getError('visitNextDate') }}
            </small>
          </div>
        </div>

        <div class="col-md-12 text-right">
          <el-checkbox
            v-if="$can('private', 'visits')"
            v-model="formData.share"
            class="d-inline mr-6 is-bordered form-control"
            label="Compartir Visita"
            name="share"
            :checked="false"
          >
          </el-checkbox>
          <base-button cy-id="save-visit" native-type="submit" type="primary">Guardar</base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { DatePicker } from 'element-ui';
import moment from 'moment';
import { Checkbox } from 'element-ui';
import swal from 'sweetalert2';

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Checkbox.name]: Checkbox,
  },

  props: {
    participants: {
      type: Array,
      default: () => [],
    },

    schedule: {
      type: Boolean,
      default: true,
    },

    visit: {
      type: Object,
      default: () => {
        return {
          userId: null,
          details: '',
          visitDate: new Date(),
          appointmentDate: new Date(),
          share: true,
          visitNextDate: new Date(),
        };
      },
    },
  },

  data() {
    return {
      modelValidations: {
        visitDate: {
          required: true,
        },

        appointmentDate: {
          required: true,
        },

        userId: {
          // required: true,
        },

        details: {
          required: true,
        },

        visitNextDate: {
          required: false,
          date_format: 'yyyy-MM-dd HH:mm',
          after: 'visitDate',
        },
      },

      formData: {
        hasParticipants: Boolean(this.participants.length),
        userId: this.visit.userId !== null ? this.visit.userId : this.$auth.user().data.id,
        details: this.visit.details,
        visitDate: moment(this.visit.visitDate).format('YYYY-MM-DD HH:mm'),
        appointmentDate: moment(this.visit.visitDate).format('YYYY-MM-DD HH:mm'),
        share: this.visit.share,
        visitNextDate: null,
      },
    };
  },

  computed: {
    ...mapFields(['visitDate', 'appointmentDate', 'details', 'visitNextDate']),
  },

  watch: {
    participants: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.formData.hasParticipants = Boolean(newVal.length);
      },
    },
  },

  created() {
    if (this.schedule) {
      this.formData.visitDate = null;
    } else {
      this.formData.appointmentDate = null;
    }
    if (this.$can('private', 'visits')) {
      this.formData.share = false;
    }
  },

  methods: {
    disabledDate(date) {
      return date < new Date();
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    saveVisit() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--datetime,
.form-group .el-date-editor--date {
  width: 100%;
}

.el-date-range-picker .el-picker-panel__footer .el-button,
.el-date-picker .el-picker-panel__footer .el-button {
  display: inline-block;
  cursor: pointer;
  position: relative;
  margin: 1px;
  font-size: 0.75rem;
  color: #11cdef;
  background-color: #fff;
  border-width: 1px;
  border-radius: 0.25rem;
  border-color: #11cdef;
  transition: all 0.15s ease;
}
</style>
